import React from 'react';
import PropTypes from 'prop-types';
import {
  Select,
  Typography,
} from 'antd';

import { PLATFORM_TYPES } from './constants';
import ModalContent from './ModalContent';

const StepPlatformType = (props) => {
  const { platformType, setPlatformType, previousPlatformType } = props;

  const platformTypeDisplayName = PLATFORM_TYPES.find((t) => t.value === previousPlatformType)?.label || 'Unknown';

  return (
    <div>
      <ModalContent
        heading="Platform type"
        body={`Last known platform type was: "${platformTypeDisplayName}"`}
      />
      <label
        htmlFor="platform-type"
        style={{
          display: 'block',
          marginBottom: 8,
        }}
      >
        Platform type
      </label>
      <Select
        defaultValue={platformType}
        id="platform-type"
        onChange={(value) => setPlatformType(value)}
        style={{ width: '100%' }}
        // keeps dropdown from showing up behind the modal
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        options={PLATFORM_TYPES}
      />
      <Typography.Text
        style={{
          display: 'block',
          marginTop: 5,
          fontSize: 14,
          color: '#B0BEC6',
        }}
      >
        Select the platform type for this deployment.
      </Typography.Text>
    </div>
  );
};

StepPlatformType.propTypes = {
  previousPlatformType: PropTypes.string,
  platformType: PropTypes.string,
  setPlatformType: PropTypes.func,
};

StepPlatformType.defaultProps = {
  previousPlatformType: '',
  platformType: '',
  setPlatformType: () => {},
};

export default StepPlatformType;
